import { Observable, Subscriber } from 'rxjs';
import axios, { AxiosPromise, AxiosRequestConfig, CancelTokenSource } from 'axios';

/* eslint-disable @typescript-eslint/no-explicit-any */
export function createObservable<T>(promiseFactory: (...args: any[]) => AxiosPromise<T>, ...args: any[]): Observable<T> {
  const config: AxiosRequestConfig = args[args.length - 1];

  const nextConfig = config
    ? { ...config }
    : {};

  const finalArgs = [...args];
  finalArgs[finalArgs.length - 1] = nextConfig;

  let cancelSource: CancelTokenSource;
  const hasCancelToken: boolean = !!nextConfig.cancelToken;

  const observable: Observable<T> = new Observable<T>((subscriber: Subscriber<T>) => {
    if (!hasCancelToken) {
      cancelSource = axios.CancelToken.source();
      nextConfig.cancelToken = cancelSource.token;
    }

    promiseFactory(...finalArgs).then((response) => {
      subscriber.next(response.data);
      subscriber.complete();
    })
      .catch((error) => {
        return subscriber.error(error);
      });
  });

  const originalSubscribe = observable.subscribe.bind(observable);

  observable.subscribe = (...args2: Parameters<typeof originalSubscribe>) => {
    const subscription = originalSubscribe(...args2);

    const originalUnsubscribe = subscription.unsubscribe.bind(subscription);

    subscription.unsubscribe = () => {
      if (cancelSource) {
        cancelSource.cancel();
      }
      originalUnsubscribe();
    };

    return subscription;
  };

  return observable;
}
